import { MenuItem } from '../models/sidebar';

const createMenuItem = (
  id: string,
  name: string,
  path: string,
  icon?: MenuItem['icon'],
  options: Partial<Omit<MenuItem, 'id' | 'name' | 'path' | 'icon'>> = {}
): MenuItem => ({
  id,
  name,
  path,
  icon,
  ...options,
});

export const menuItems: MenuItem[] = [
  createMenuItem('onboarding', 'ONBOARDING', '/onboarding', 'LayoutDashboard'),
  createMenuItem('task-manager', 'TASK_MANAGER', '/task-manager', 'Presentation', {
    isIntegrated: true,
  }),
  createMenuItem('profile', 'PROFILE', '/profile', 'User'),
];
